import React from "react";
import ForRentWigsList from "./for-rent-wigs-list/for-rent-wigs-list";

const ForRentWigsContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForRentWigsList/>
            </div>
        </>
    )
};

export default ForRentWigsContainer;